import React, { FC } from 'react'
import { StyledDivider, StyledMenuItem } from '../ContentNavMenuItem.styled'
import { HomeIcon } from '../assets/HomeIcon'

export const HomeMenuItem: FC = () => {
    const handleNavigate = () => {
        window.scrollTo({
            top: 0,
            behavior: 'instant' as ScrollBehavior,
        })
    }

    return (
        <>
            <StyledMenuItem isSelected={false} onClick={() => handleNavigate()}>
                <HomeIcon />
            </StyledMenuItem>
            <StyledDivider />
        </>
    )
}
